import { useQuery } from '@apollo/client/react';
import type { GetStaticPaths, GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';

import { WidgetsApp } from '@/components';

import { CompetitionWidget } from '../../components/Widgets';
import { GetWidgetDocument } from '../_internal/Widget.query.generated';

const Competition = () => {
  const router = useRouter();

  const getWidget = useQuery(GetWidgetDocument, {
    variables: {
      widgetId: Number(router.query.widgetId),
      cacheTTL: router.query.noCache ? 0 : undefined,
    },
    skip: !router.query.widgetId,
    context: {
      role: 'anonymous',
    },
  });

  const widget = getWidget.data?.widgets_widget_by_pk;

  return (
    <WidgetsApp widget={widget}>
      <CompetitionWidget
        competition_id={widget?.widget_competitions?.[0]?.competition_id}
      />
    </WidgetsApp>
  );
};

export const getStaticPaths: GetStaticPaths = () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'fr', [
      'snc-components',
      'snc-core',
      'common',
    ])),
  },
});

export default Competition;
